module.exports = __webpack_public_path__ + "img/11.f4ea6741.jpg";